<template>
  <interview-layout :touch-and-validate="touchAndValidate" :showFooter="isEersteStap" class="flex-grow-1">
    <!-- inner wrapper used for centering -->
    <div class="container-narrow">
      <div class="d-flex justify-content-center" style="margin-top:-4em" v-if="isEersteStap">
        <img
          src="@/assets/img/eerste_stap.png"
          alt="De eerste stap logo"
          class="w-75"
        />
      </div>
      <!-- title above form card -->
      <h1 class="px-4 text-primary fade-in-up-enter-active animation-slowest">{{ greeting }}</h1>
      <h5 class="px-4 pb-3 fade-in-up-enter-active animation-slowest delay-200 max-100">Zie direct of u in aanmerking komt.</h5>
      <!-- form card -->
      <base-card inner-class="container-narrow w-100" color="alternate" :outer-padding="true">
        <base-form @submit="onSubmit">
          <!-- inputs -->
          <div class="d-sm-flex gap-5">
            <base-input name="PostalCode" placeholder="0000AA"
              v-model:value="lead.address.PostalCode" :validator="v$.address.PostalCode" @update:value="fetchAddress" :debounce="1000">
              Postcode
            </base-input>
            <base-input name="StreetNumber" fieldWidth="150px"
              v-model:value="lead.address.StreetNumber" :validator="v$.address.StreetNumber" @update:value="fetchAddress" :debounce="1000">
              Huisnummer
            </base-input>
          </div>
          <!-- <transition name="fade-in-up">
            <div v-show="lead.address.PostalCode && lead.address.StreetNumber">
              <base-input name="Street" placeholder="Straatnaam" :disabled="bagMatch"
                v-model:value="lead.address.Street" :validator="v$.address.Street">
                Straatnaam
              </base-input>

              <base-input name="City" placeholder="Plaatsnaam" :disabled="bagMatch"
                v-model:value="lead.address.City" :validator="v$.address.City">
                Plaatsnaam
              </base-input>
            </div>
          </transition> -->

          <transition name="fade-in-up">
            <div v-show="true">
              <base-card v-show="true" color="light" class="mt-2" inner-class="d-flex flex-column" :stretch-inner="true">
                <div class="d-flex align-items-center">
                  <!-- map pin icon -->
                  <i :class="addressIconClass"></i>
                  <div>
                    <span key="addr_display" class="fw-600" v-show="addressStatus == 'eligible' || addressStatus == 'ineligible'">
                      {{lead.address.Street}} {{ lead.address.StreetNumber }}, {{ lead.address.City }}
                    </span>
                    <!-- show confirmation if address is in list -->
                    <span key="loading" class="text-muted mt-2" v-show="addressStatus == 'busy'">
                      Adres controleren...
                    </span>
                    <span key="invalid" class="text-danger mt-2" v-show="addressStatus == 'invalid'">
                      Wij kunnen geen gegevens vinden over dit adres. Controleer de postcode en het huisnummer.
                    </span>
                    <span key="empty" class="text-muted fst-italic mt-2" v-show="addressStatus == 'incomplete'">
                      Vul uw postcode en huisnummer in.
                    </span>
                  </div>
                  <!-- energy label -->
                  <energy-label v-if="lead.address.Energielabel__c" :label="lead.address.Energielabel__c" style="margin-left: auto;" />
                </div>
                
                <!-- <div v-if="addressStatus == 'eligible'" class="d-flex mt-2">
                  <i class="bi bi-check-circle-fill me-2 text-success"></i>
                  <div>
                    <span class="fw-600 small text-success" v-show="addressStatus == 'eligible'">
                      Uw adres staat op de lijst met geselecteerde adressen.
                    </span>
                  </div>
                </div> -->
              </base-card>

              <base-card v-show="lead.address.pc_m29_municipality && lead.address.m29_100pct" color="light" class="mt-2" inner-class="d-flex flex-column" :stretch-inner="true">
                <!-- <info-item 
                :class="{'mb-4': lead.address.m29_100pct}"
                icon="bi-calendar-week text-success"
                v-if="lead.address.pc_m29_open_from_string">
                  <span class="fw-500 text-secondary d-block">
                    Openstelling postcodegebied:
                  </span>
                  <span class="fw-600">
                    {{ lead.address.pc_m29_open_from_string }}
                  </span>
                </info-item> -->
                <info-item 
                  icon="bi-percent text-success"
                  v-if="lead.address.m29_100pct"
                >
                  <span class="fw-500 text-secondary d-block">
                    Vergoedingpercentage:
                  </span>
                  <span class="fw-600">
                    {{ lead.address.m29_100pct ? '100% van de kosten tot €40.000' : '50% van de kosten, max. €20.000' }}
                  </span>
                </info-item>
              </base-card>

              <!-- if pc_m29_municipality == false, show warning -->
              <base-card v-show="lead.address.pc_m29_municipality === 0" color="danger" class="mt-2" inner-class="d-flex flex-column" :stretch-inner="true">
                <info-item icon="bi-x-octagon-fill" color="danger">
                  <div class="text-body">
                    <strong class="fw-600 text-danger d-block mb-2">Dit adres valt buiten het werkgebied van Nij Begun.</strong>
                    <p class="mb-2">
                      Denkt u wel onder de regeling te vallen? Ga dan naar <a class="text-danger" href="https://isolatie.nijbegun.nl" target="_blank">isolatie.nijbegun.nl</a> om de juiste ondersteuner te vinden voor uw adres.
                    </p>
                  </div>
                </info-item>
                <!-- button to navigate to isolatie.nijbegun.nl (using base-button) -->
                <base-button
                  class="ms-auto me-auto small mt-4 mb-0"
                  variant="minimal-danger"
                  icon="bi-box-arrow-up-right"
                  tag="a"
                  href="https://isolatie.nijbegun.nl"
                  target="_blank"
                  rel="noopener"
                >
                  Ga naar isolatie.nijbegun.nl
                </base-button>
              </base-card>
            </div>
          </transition>

          <base-card v-show="false" color="light" class="mt-2" :stretch-inner="true">
            <h5 class="mb-2">Speciale wijkaanpak</h5>
            <info-item v-if="addressStatus == 'eligible'" color="success" icon="bi-check-circle-fill">
              <strong class="fw-600">Dit adres staat op de lijst</strong>
            </info-item>
            <info-item v-if="addressStatus == 'ineligible'" color="danger" icon="bi-exclamation-circle-fill">
              <strong class="fw-600">Dit adres staat niet op de lijst</strong>
            </info-item>
            <hr class="opacity-25"/>
            <!-- explanation if eligible -->
            <div v-if="addressStatus == 'eligible'" class="mt-2 mb-0">
              <div class="mb-3 small opacity-50">
                <i>Wat betekent dit?</i>
              </div>
              <info-item icon="bi-check-circle-fill text-success" class="mb-1">
                U komt in aanmerking voor een speciale aanpak in uw wijk.
              </info-item>
              <info-item icon="bi-check-circle-fill text-warning" class="mb-1">
                U kunt meedoen als uw woning technisch geschikt is voor de maatregel.
              </info-item>
            </div>
            <!-- explanation if ineligible -->
            <div v-if="addressStatus == 'ineligible'" class="mt-2 mb-0">
              <div class="mb-3 small opacity-50">
                <i>Wat betekent dit?</i>
              </div>
              <info-item icon="bi-x-circle-fill text-danger" class="mb-1">
                U komt (waarschijnlijk) niet in aanmerking voor deze speciale aanpak.
              </info-item>
              <info-item icon="bi-check-circle-fill text-success" class="mb-1">
                U kunt w&eacute;l doorgaan met uw aanvraag, u valt dan onder de reguliere aanpak.
              </info-item>
              <info-item icon="bi-check-circle-fill text-success" class="mb-1">
                U wordt op individuele basis geholpen door onze adviseur.
              </info-item>
            </div>
            <hr class="opacity-25" v-if="addressStatus == 'ineligible'" />
            <div class="mt-2 mb-0" v-if="addressStatus == 'ineligible'">
              <info-item icon="bi-question-circle-fill text-info" class="mb-1" color="secondary">
                Denkt u dat dit een fout is? Neem dan telefonisch contact op.
              </info-item>
            </div>
          </base-card>

          <div class="mt-3 mb-3">
            <issue-feedback :issue="qualStore.global.rules.AssignedPartner" />

            <div v-if="hasExternalPartner">
              <base-input
                class="mt-3"
                type="radiobuttons"
                :options="yesNo"
                name="WantsToRegisterAnyway"
                v-model:value="lead.registration.WantsToRegisterAnyway"
                :validator="v$.registration.WantsToRegisterAnyway">
                Wilt u zich toch bij ons aanmelden?
              </base-input>

              <base-input
                v-if="lead.registration.WantsToRegisterAnyway === true"
                class="mt-3"
                type="textarea"
                :rows="3"
                name="RegisterAnywayReason"
                placeholder="Geef een reden (maximaal 180 tekens)"
                v-model:value="lead.registration.RegisterAnywayReason"
                :validator="v$.registration.RegisterAnywayReason"
                @update:value="onUpdateRegisterReason">
                Waarom wilt u zich toch bij ons aanmelden?
              </base-input>

              <div
                v-if="lead.registration.WantsToRegisterAnyway === true"
                class="small text-muted mt-1"
              >
                {{ registerReasonLength }}/180
              </div>
            </div>
          </div>

          <call-request-card v-if="false" class="mt-4" show-phone-number="true" />

          <!-- buttons -->
          <button-row class="mt-4">
            <base-button class="ms-auto" icon="bi-arrow-right" type="submit" :disabled="v$.address.$invalid || uiStore.addressFetchBusy || !canProceedWithPartnerIssue || lead.address.pc_m29_municipality == false">Volgende</base-button>
          </button-row>
        </base-form>
      <!-- form card end -->
      </base-card>
      <!-- <button-row class="mt-2">
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row> -->
      <!-- inner wrapper end -->
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue"
  import BaseCard from '@/components/BaseCard.vue'
  import BaseForm from "@/components/BaseForm.vue"
  import BaseInput from "@/components/BaseInput.vue"
  import BaseButton from "@/components/BaseButton.vue"
  import ButtonRow from "@/components/ButtonRow.vue"
  import CallRequestCard from "@/components/CallRequestCard.vue"
  import InfoItem from "@/components/InfoItem.vue"
  import EnergyLabel from "@/components/EnergyLabel.vue"
  import IssueFeedback from "@/components/IssueFeedback.vue"
  
  import { useAllStores } from "@/helpers/UseAllStores"
  import { CommonComposable } from "@/helpers/CommonComposable"
  import { FlowService } from "@/services/FlowService"
  import { toNormalisedString } from "@/helpers/DutchHouseNumber"

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseForm,
      BaseInput,
      BaseButton,
      ButtonRow,
      CallRequestCard,
      InfoItem,
      EnergyLabel,
      IssueFeedback
    },
    setup(props, context) {
      return { ...CommonComposable(props, context), ...useAllStores() };
    },
    data() {
      return {
        yesNo: [
          {
            label: 'Ja',
            value: true
          },
          {
            label: 'Nee',
            value: false
          },
        ]
      };
    },
    computed: {
      isEersteStap() {
        return this.lead.meta.LeadSource.toLowerCase().includes('eerste-stap');
      },
      greeting() {
        if (this.uiStore.isExistingCustomer && !this.v$.address.$invalid) {
          return 'Kloppen deze gegevens?';
        } else {
          return 'Wat is uw adres?';
        }
      },
      addressComplete() {
        return (this.lead.address.PostalCode && this.lead.address.StreetNumber);
      },
      isInvalidAddress() {
        return !this.lead.address.id && !this.uiStore.addressFetchBusy && this.addressComplete;
      },
      addressStatus() {
        // if busy, return 'busy'
        // if invalidAddress, return 'invalid'
        // if this.lead.Eligible_ms === true or false (and not null!), return 'eligible' or 'ineligible'
        // else return 'incomplete'
        if (this.uiStore.addressFetchBusy) {
          return 'busy';
        } else if (this.isInvalidAddress) {
          return 'invalid';
        } else if (this.lead.Eligible_ms === true) {
          return 'eligible';
        } else if (this.lead.Eligible_ms === false) {
          return 'ineligible';
        } else {
          return 'incomplete';
        }
      },
      addressIconClass() {
        const classes = { 'bi bi-geo-alt-fill me-2': true };
        if (this.lead.address.pc_m29_municipality) {
          classes['text-primary'] = true;
        } else if (this.addressStatus == 'invalid') {
          classes['text-danger'] = true;
        } else if (this.addressStatus == 'busy' || this.addressStatus == 'incomplete') {
          classes['text-muted'] = true;
        } else if (this.addressStatus == 'eligible') {
          classes['text-primary'] = true;
        } else if (this.addressStatus == 'ineligible') {
          classes['text-warning'] = true;
        }
        return classes;
      },
      hasAssignedPartnerIssue() {
        return !!this.qualStore.global.rules.AssignedPartner;
      },
      hasExternalPartner() {
        const partner = (this.lead.address.assigned_partner || '').toString().trim().toLowerCase();
        return partner === 'rel' || partner === 'energieploeg' || partner === 'jgh bespaaradvies';
      },
      registerReasonLength() {
        return (this.lead.registration.RegisterAnywayReason || '').length;
      },
      canProceedWithPartnerIssue() {
        if (!this.hasExternalPartner) {
          return true;
        }
        if (this.lead.registration.WantsToRegisterAnyway === false) {
          return true;
        }
        if (this.lead.registration.WantsToRegisterAnyway !== true) {
          return false;
        }
        const reason = (this.lead.registration.RegisterAnywayReason || '').trim();
        return reason.length > 0 && reason.length <= 180;
      }
    },
    methods: {
      fetchAddress() {
        if (this.addressStore.diffLeadAddress()) {
          // reset
          this.addressStore.clearAddressData(true);
          // if PostalCode and StreetNumber are filled, and PostalCode >= 6 chars
          if (this.lead.address.PostalCode && this.lead.address.StreetNumber && this.lead.address.PostalCode.length >= 6) {
            // fetch address
            this.addressStore.fetchAddress(this.lead.address.PostalCode, this.lead.address.StreetNumber);
          } else {
            console.log('fetchAddress: PostalCode and StreetNumber are not filled or PostalCode < 6 chars');
          }
        } else {
          console.log('Address not different.');
        }
      },
      touchAndValidate() {
        this.v$.address.$touch();
        return !this.v$.address.$invalid;
      },
      onSubmit() {
        if (!this.canProceedWithPartnerIssue) {
          return;
        }
        if (this.touchAndValidate()) {
          FlowService.pushNext(this);
        }
      },
      onPrev() {
        FlowService.pushPrev(this);
      }
    },
  mounted() {
      this.fetchAddress();
    },
    watch: {
      // remove spaces from postal code and house number
      'lead.address.PostalCode': {
        handler(newValue) {
          // remove all whitespace
          this.lead.address.PostalCode = newValue ? newValue.replace(/\s/g, '') : null;
        },
        immediate: true
      },
      'lead.address.StreetNumber': {
        handler(newValue) {
          // use DutchHouseNumber toNormalisedString
          this.lead.address.StreetNumber = toNormalisedString(newValue);
        },
        immediate: true
      }
    }
  }
</script>

<style lang="scss">
</style>